import { OnInit, OnDestroy, Component, Output, EventEmitter, Input } from '@angular/core';
import { NotifyService } from 'src/app/core/services/notify.service';
import { interval, Subscription, BehaviorSubject, concat } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { isBuffer } from 'util';
import { CommonService } from 'src/app/core/services/common.service';
import { EnumNotificationType } from 'src/app/core/constants/notification';
import { ContractLotService } from 'src/app/core/services/contract-lot.service';
import { ProcessingService } from 'src/app/core/services/processing.service';
import { ImportLotService } from 'src/app/core/services/import-lot.service';
import { LotType } from 'src/app/core/constants/lot-type';
import { Message } from 'src/app/core/class/message';
import { EnvService } from 'src/app/core/services/env.service';
import { HeaderComponent } from 'src/app/shared/components/header/enterprise-header/header.component';
import { HeaderCountService } from 'src/app/core/services/header-count.service';

declare function clearSelectionJ(): any;

export interface Process {
  id: string,
  code: string,
  createdTime: string,
  status: string,
  doneContract: number,
  totalContract: number,
  percent: number,
  type: string
}

@Component({
  selector: 'app-processing',
  styleUrls: ['./processing.component.scss'],
  templateUrl: './processing.component.html'
})
export class ProcessingComponent implements OnInit, OnDestroy {
  processes: Process[] = [];
  public totalProcesses: number = 0;
  usType: any;
  EnumNotificationType = EnumNotificationType;
  timeOut: any = null;
  isProcess = true;
  mapIdPercent = new Map();
  constructor(
    private notifyService: NotifyService,
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    public message: Message,
    public importLotService: ImportLotService,
    public contractLotService: ContractLotService,
    public processingService: ProcessingService,
    private hd: HeaderComponent,
    private env: EnvService,
    private headerCountService: HeaderCountService,
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        // trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
        // if you need to scroll back to top, here is the right place
        window.scrollTo(0, 0);
      }
    });
    // hiện ngay số cũ từ cache để badge không nháy về rỗng khi chuyển tab
    if (this.headerCountService.processes !== null) {
      this.processes = this.headerCountService.processes;
      this.totalProcesses = this.headerCountService.totalProcesses;
    }
  }

  /**
   * OnInit
   */
  ngOnInit() {
    const permission = localStorage.getItem('permissions');
    this.initSocketConnection();
    if (permission.includes('0') || permission.includes('1') || permission.includes('2')) {
      this.getTaskProcessing();
    }
    // this.contractLotService.processingStart.subscribe(ref => {
    //   if (ref) {
    //     if (this.timeOut) {
    //       this.contractLotService.processingStart.next(false);
    //     } else {
    //       this.getTaskProcessing();
    //     }
    //   }
    // })
  }

  initSocketConnection() {
    const currentUser = localStorage.getItem('token') || sessionStorage.getItem('token');
    this.hd.stompClient.connect({ token: currentUser }, () => {
      this.hd.stompClient.subscribe('/users/topic/import-lot', (message) => {
        if(message) {
          let parsed_msg = JSON.parse(message.body);
          console.log(`🙂 1️⃣ ~ msg incomming: \n${JSON.stringify(parsed_msg, null, 4)}`)
          if(this.processes.map(el => el.code + '_STEP_2_DONE').includes(parsed_msg.status)){
            this.getProcessing(parsed_msg);
          } else if(this.processes.map(el => el.code + '_STEP_2_PER_RECORD').includes(parsed_msg.status)) {
            let data = parsed_msg.content
            console.log(`🙂 2️⃣ ~ data step 2: \n${JSON.stringify(data, null, 4)}`)
            let $ = this.mapIdPercent.get(data.lotId);
            console.log(`🙂 3️⃣ ~ $ in map: \n${JSON.stringify($, null, 4)}`)
            if($) {
              this.mapIdPercent.set(data.lotId, {
                processed: $.processed + 1,
                total: $.total,
              })
              console.log(`🙂 4️⃣ ~ map after process: \n${this.mapIdPercent}`)
            }
            this.processes.map(el => {
              console.log(`🙂 5️⃣ ~ this.processes: \n${JSON.stringify(this.processes, null, 4)}`)
              let datum = this.mapIdPercent.get(this.decodeId(el.id));

              console.log(`🙂 6️⃣ ~ datum in this.processes: \n${JSON.stringify(datum, null, 4)}`)
              let percent = Math.round(datum.processed / datum.total * 100);

              console.log(`🙂 7️⃣ ~ calc percent: \n${JSON.stringify(percent, null, 4)}`)
              el.percent = percent ? percent : el.percent;

              console.log(`🙂 8️⃣ ~ percent final: \n${JSON.stringify(el.percent, null, 4)}`)
              return el;
            })

            console.log(`🙂 9️⃣ ~ this.processes after calc: \n${JSON.stringify(this.processes, null, 4)}\n\n\n\n\n`)
            if(data.type == 'CONTRACT_LOT')
              this.processingService.recordSocketContractQueue.next(data);
            else
              this.processingService.recordSocketQueue.next(data);
          } else if(this.processes.map(el => el.code + '_STEP_4_DONE').includes(parsed_msg.status)) {
            this.getProcessingNoPolling();
          }
        }
      });
    }, (error) => {
      // console.log(error);
    });
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
  }

  parsedText(text) {
    const dom = new DOMParser().parseFromString(
      '<!doctype html><body>' + text,
      'text/html');
    const decodedString = dom.body.textContent;
    return decodedString;
  }

  getTaskProcessing() {
    console.log(`🙂 🔥 ~ getTaskProcessing()`)
    if(this.isProcess){
      this.importLotService.getAllProcessing({ size: 20 }).subscribe(res => {
        this.isProcess = false
        this.timeOut = null;
        if (!res || !res.data) {
          return;
        }
        const newTotal = res.data.total;
        const newProcesses = res.data.content.map(item => {
          // item.percent = Math.round(item.doneContract / item.totalContract * 100);
          this.mapIdPercent.set(this.decodeId(item.id), {
            processed: item.doneContract ? item.doneContract : 0,
            total: item.totalContract
          });
          let $ = this.mapIdPercent.get(this.decodeId(item.id))
          item.percent = Math.round($.processed / $.total * 100);
          return item;
        });
        // chỉ gán lại UI khi số mới khác cache -> số không đổi thì badge đứng yên, không nháy
        if (this.headerCountService.setProcessingData(newTotal, newProcesses)) {
          this.totalProcesses = newTotal;
          this.processes = newProcesses;
          this.processingService.processingTask.next(this.processes);
        }
        // if (res.data.content && res.data.content.length) {
          // const importUserCustomer = res.data.content.find((item) => {
          //   return item.type === LotType.USER_LOT || item.type === LotType.CUSTOMER_LOT
          // })
          // if (importUserCustomer) {
          //   this.timeOut = setTimeout(() => {
          //     this.isProcess = true;
          //     this.getTaskProcessing();
          //   }, 30000)
          // } else {
          //   this.timeOut = setTimeout(() => {
          //     this.isProcess = true;
          //     this.getTaskProcessing();
          //   }, 30000)
          // }
        // }
      })
    }
  }

  getProcessingNoPolling() {
    console.log(`🙂 🔥 ~ getProcessingNoPolling()`)
    this.importLotService.getAllProcessing({ size: 20 }).subscribe(res => {
      this.timeOut = null;
      if (!res || !res.data) {
        return;
      }
      const newTotal = res.data.total;
      const newProcesses = res.data.content.map(item => {
        // item.percent = Math.round(item.doneContract / item.totalContract * 100);
        if(!this.mapIdPercent.get(this.decodeId(item.id))) {
          this.mapIdPercent.set(this.decodeId(item.id), {
            processed: 0,
            total: item.totalContract
          });
        }
        let $ = this.mapIdPercent.get(this.decodeId(item.id))
        item.percent = Math.round($.processed / $.total * 100);
        return item;
      });
      // chỉ gán lại UI khi số mới khác cache -> số không đổi thì badge đứng yên, không nháy
      if (this.headerCountService.setProcessingData(newTotal, newProcesses)) {
        this.totalProcesses = newTotal;
        this.processes = newProcesses;
        this.processingService.processingTask.next(this.processes);
      }
    })
  }

  getProcessing(parsed_msg) {
    this.processes.map($ => {
      console.log(`🙂 🔥 ~ getProcessing()`)
      if(this.decodeId($.id) == this.decodeId(parsed_msg.content.lotId)) {
        let content = parsed_msg.content;
        this.mapIdPercent.set(this.decodeId(content.lotId), {
          processed: 0,
          total: content.totalRecords
        });
        $.id = content.lotId,
        $.code = content.code,
        $.createdTime = content.createdTime,
        $.status = content.status,
        $.doneContract = 0,
        $.totalContract = content.totalRecords,
        $.percent = 0,
        $.type = content.type
      } else return $;
    })
    this.processingService.processingTask.next(this.processes);
  }

  decodeId(id: string) {
    const idDecode = atob(id);
    const findNumber = idDecode.match(/[0-9]{1,}/g);
    if (findNumber && findNumber.length) {
      return Number(findNumber[findNumber.length - 1]);
    }
    return null;
  }

  getTitle(type: any) {
    switch (type) {
      case 'CUSTOMER_LOT':
        return this.message.getMessage('processing_header.processing_customer_title');
      case 'USER_LOT':
        return this.message.getMessage('processing_header.processing_user_title');
      default:
        return '';
    }
  }

  redirect(process: Process) {
    switch (process.type) {
      case LotType.CONTRACT_LOT: {
        this.router.navigateByUrl('/home-enterprise/contract-lot/' + process.id);
        break;
      }
      case LotType.USER_LOT: {
        this.router.navigateByUrl('/home-enterprise/import-user/' + process.id);
        break;
      }
      case LotType.CUSTOMER_LOT: {
        this.router.navigateByUrl('/home-enterprise/import-customer/' + process.id);
        break;

      }
      case LotType.CONTRACT_MOHA_LOT: {
        this.router.navigateByUrl('/home-enterprise/contract-lot-moha/' + process.id);
        break;

      }
      case LotType.CONTRACT_MOHA_STANDARDIZED_LOT: {
        this.router.navigateByUrl('/home-enterprise/contract-lot-standardized/' + process.id);
        break;

      }
      case LotType.CONTRACT_MOHA_LOT_DIGITAL: {
        this.router.navigateByUrl('/home-enterprise/contract-digital-add-lot/add-lot/' + process.id);
        break;
      }
    }

  }
}

